import {
  PartClaimed,
  PartInCart,
  PartStandsAlone
} from '../hooks/useTransformServiceItems/useTransformServiceItems'

export function displayPartsTechPartName(
  part: PartClaimed | PartInCart,
  showPartBrands: boolean,
  showPartNumbers: boolean
) {
  let displayedName = part.shortName!
  if (!showPartBrands && part.brandName) {
    displayedName = displayedName
      .replace((part.brandDisplayName || part.brandName).trim(), '')
      .trim()
  }
  let cumulativePartName =
    showPartBrands && part.brandName
      ? `${displayedName} -- ${part.brandName}`
      : displayedName

  if (showPartNumbers) {
    cumulativePartName += ` -- ${part.partNumber}`
  }

  return cumulativePartName
}

export function displayStandAlonePartName(partStandsAlone: PartStandsAlone) {
  let cumulativePartName = partStandsAlone.partName!
  if (partStandsAlone.partNumber) {
    cumulativePartName += ` -- ${partStandsAlone.partNumber}`
  }
  return cumulativePartName
}
